import React from "react"
import SaleStage from "../components/SaleStage"

class Step6SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { houseTurnover={} } = (client && client.stages_of_sale) || {};

        const {
            letterOfGuaranteeFile,
            letterOfGuaranteeDate,
            withOccupancyPermitFile,
            withOccupancyPermitDate,
            sginedNotarizedAffidavitOfFinalAcceptanceFile,
            sginedNotarizedAffidavitOfFinalAcceptanceDate,
            signedMoveInAuthorityAndMoveInClearance,
            clearedEquityPayment,
            dateLoanTakeout,
            signedNotarizedPromissoryNote,
            isCompleted,
            completionDate,
            others=[]
        } = houseTurnover;

        const step6Fields = [
            { key: 'letterOfGuaranteeFile', type: 'file', label: 'Letter Of Guarantee File', value: letterOfGuaranteeFile},
            { key: 'letterOfGuaranteeDate', type: 'date', label: 'Letter Of Guarantee Date', value: letterOfGuaranteeDate},
            { key: 'withOccupancyPermitFile', type: 'file', label: 'With Occupancy Permit File', value: withOccupancyPermitFile},
            { key: 'withOccupancyPermitDate', type: 'date', label: 'With Occupancy Permit Date', value: withOccupancyPermitDate},
            { key: 'sginedNotarizedAffidavitOfFinalAcceptanceFile', type: 'file', label: 'Signed Notarized Affidavit Of Final Acceptance File', value: sginedNotarizedAffidavitOfFinalAcceptanceFile},
            { key: 'sginedNotarizedAffidavitOfFinalAcceptanceDate', type: 'date', label: 'Signed Notarized Affidavit Of Final Acceptance Date', value: sginedNotarizedAffidavitOfFinalAcceptanceDate},
            { key: 'signedMoveInAuthorityAndMoveInClearance', type: 'date', label: 'Signed Move In Authority And Move In Clearance', value: signedMoveInAuthorityAndMoveInClearance},
            { key: 'clearedEquityPayment', type: 'date', label: 'Cleared Full Payment of Equity (DP/MF)', value: clearedEquityPayment},
            { key: 'dateLoanTakeout', type: 'date', label: 'Date Loan Takeout', value: dateLoanTakeout},
            { key: 'signedNotarizedPromissoryNote', type: 'file', label: 'Signed Notarized Promissory Note', value: signedNotarizedPromissoryNote},
        ]

        return (
            !!client ? <SaleStage 
                title="House Turnover"
                fields={step6Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="houseTurnover"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step6SS
